import { Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DeviceDetectService } from "../../../services/device-detect.service";
import { NgStyle } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-payment-modal",
    templateUrl: "./payment-modal.component.html",
    styleUrls: ["./payment-modal.component.css"],
    imports: [
        NgStyle,
        TranslateModule,
        MatIcon,
    ]
})
export class PaymentModalComponent implements OnInit {
  @Input() content: string;
  isMobile: boolean;
  @Output() goToPay: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private dialogRef: MatDialogRef<PaymentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private deviceDetectService: DeviceDetectService,
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceDetectService.isMobile;
    this.content = this.data.content;
  }

  onClose() {
    this.dialogRef.close();
  }

  onGoToPay(accept: boolean) {
    this.goToPay.emit(accept);
    this.onClose();
  }

}
